import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bar" }
const _hoisted_2 = ["min", "max", "step", "value"]
const _hoisted_3 = { class: "caption" }
const _hoisted_4 = { class: "min-caption" }
const _hoisted_5 = { class: "bar-inner" }
const _hoisted_6 = ["min", "max", "step", "value"]
const _hoisted_7 = { class: "caption" }
const _hoisted_8 = { class: "max-caption" }
const _hoisted_9 = {
  key: 0,
  class: "ruler"
}
const _hoisted_10 = {
  key: 1,
  class: "sub-ruler"
}
const _hoisted_11 = {
  key: 2,
  class: "labels"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([$props.baseClassName, $data.rangeMarginValue === 0 ? 'zero-ranage-margin' : '']),
    onMousewheel: _cache[10] || (_cache[10] = _withModifiers((...args) => ($options.onMouseWheel && $options.onMouseWheel(...args)), ["prevent","stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "bar-left",
        style: _normalizeStyle({ width: $options.barMin + '%' }),
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.onBarLeftClick && $options.onBarLeftClick(...args)))
      }, null, 4 /* STYLE */),
      _createElementVNode("input", {
        class: "input-type-range input-type-range-min",
        type: "range",
        min: $options.minimum,
        max: $options.maximum,
        step: $props.step,
        value: $data.valueMin,
        onInput: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onInputMinChange && $options.onInputMinChange(...args)), ["stop","prevent"]))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
      _createElementVNode("div", {
        class: "thumb thumb-left",
        onMousedown: _cache[2] || (_cache[2] = (...args) => ($options.onLeftThumbMousedown && $options.onLeftThumbMousedown(...args))),
        onTouchstart: _cache[3] || (_cache[3] = (...args) => ($options.onLeftThumbMousedown && $options.onLeftThumbMousedown(...args)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString($props.minCaption || $options.barMinVal), 1 /* TEXT */)
        ])
      ], 32 /* NEED_HYDRATION */),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "bar-inner-left",
          onClick: _cache[4] || (_cache[4] = (...args) => ($options.onInnerBarLeftClick && $options.onInnerBarLeftClick(...args)))
        }),
        _createElementVNode("div", {
          class: "bar-inner-right",
          onClick: _cache[5] || (_cache[5] = (...args) => ($options.onInnerBarRightClick && $options.onInnerBarRightClick(...args)))
        })
      ]),
      _createElementVNode("input", {
        class: "input-type-range input-type-range-max",
        type: "range",
        min: $options.minimum,
        max: $options.maximum,
        step: $props.step,
        value: $data.valueMax,
        onInput: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.onInputMaxChange && $options.onInputMaxChange(...args)), ["stop","prevent"]))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6),
      _createElementVNode("div", {
        class: "thumb thumb-right",
        onMousedown: _cache[7] || (_cache[7] = (...args) => ($options.onRightThumbMousedown && $options.onRightThumbMousedown(...args))),
        onTouchstart: _cache[8] || (_cache[8] = (...args) => ($options.onRightThumbMousedown && $options.onRightThumbMousedown(...args)))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString($props.maxCaption || $options.barMaxVal), 1 /* TEXT */)
        ])
      ], 32 /* NEED_HYDRATION */),
      _createElementVNode("div", {
        class: "bar-right",
        style: _normalizeStyle({ width: $options.barMax + '%' }),
        onClick: _cache[9] || (_cache[9] = (...args) => ($options.onBarRightClick && $options.onBarRightClick(...args)))
      }, null, 4 /* STYLE */)
    ]),
    ($props.ruler)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.stepCount, (n) => {
            return (_openBlock(), _createElementBlock("div", {
              key: n,
              class: "ruler-rule"
            }))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($options.subStepCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.subStepCount, (n) => {
            return (_openBlock(), _createElementBlock("div", {
              key: n,
              class: "ruler-sub-rule"
            }))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.scaleLabels, (label) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "label",
              key: label
            }, _toDisplayString(label), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 34 /* CLASS, NEED_HYDRATION */))
}